import { NgClass } from "@angular/common";
import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { ClassDirective } from "@ngbracket/ngx-layout/extended";
import { SecurityService } from "@tylertech/core-module";
import { ForgeExpansionPanelModule, ForgeListItemModule, ForgeListModule, ForgeOpenIconModule } from "@tylertech/forge-angular";
import { MetadataNavigationLeafComponent } from "./metadataNavigationLeaf.component";
import { Leaf, OnContextEvent, Tree, TreeNode } from "./tree";

interface HasExpanded
{
    expanded?: boolean;
}

interface HasSelected
{
    selected?: boolean;
}

interface HasDisabled
{
    disabled?: boolean;
}

interface HasErrors
{
    hasError?: boolean;
}

@Component({
    selector: "metadata-navigation-tree",
    templateUrl: "./metadataNavigationTree.tmpl.html",
    imports: [
        ClassDirective,
        ForgeExpansionPanelModule,
        ForgeListItemModule,
        ForgeListModule,
        ForgeOpenIconModule,
        MetadataNavigationLeafComponent,
        NgClass,
    ],
})
export class MetadataNavigationTreeComponent
{
    private readonly $securityService = inject(SecurityService);

    @Input()
    readonly nodes: ReadonlyArray<TreeNode>;

    @Input()
    public readonly isChild: boolean = false;

    @Output() public onClick = new EventEmitter<string>();

    @Output() public onContextMenu = new EventEmitter<OnContextEvent>();

    readonly compactMode: boolean = this.$securityService.IsCompactMode;

    isLeaf(node: TreeNode): boolean
    {
        return Leaf.isLeaf(node);
    }

    toggleNode(node: Tree): void
    {
        node.expanded = !node.expanded;
    }

    isExpanded(node: TreeNode): boolean
    {
        return (node as HasExpanded).expanded === true;
    }

    getToggleClass(node: Tree): Record<string, boolean>
    {
        // TODO - these classes are defined in library/search, are we properly dependent on that module here??????
        return {
            "filter-icon-expand": node.expanded,
            "filter-icon-collapse": !node.expanded,
        };
    }

    select(id: string): void
    {
        this.onClick.emit(id);
    }

    context(event: OnContextEvent): void
    {
        this.onContextMenu.emit(event);
    }

    trackById(_index: number, node: TreeNode): string
    {
        return node.id;
    }

    isSelected(node: TreeNode): boolean
    {
        return (node as HasSelected).selected === true;
    }

    HasErrors(node: TreeNode): boolean
    {
        return (node as HasErrors).hasError === true;
    }

    isDisabled(node: TreeNode): boolean
    {
        return (node as HasDisabled).disabled === true;
    }

    getChildren(node: TreeNode): Array<TreeNode>
    {
        return node instanceof Tree
            ? node.nodes
            : [];
    }
}
